export const benefits = [
    { heading: "Prime Eligibility", content: "Products are eligible for Maelano Prime, increasing visibility and sales." },
    { heading: "Storage and Handling", content: "Maelano manages all storage, packaging, and shipping." },
    { heading: "Customer Service", content: "Maelano provides 24/7 customer service and returns handling." },
    { heading: "Fast and Reliable Shipping", content: "Access to Maelano’s reliable and fast shipping network." },
    { heading: "Inventory Management", content: "Tools to manage inventory and track shipments in real-time." },
];

export const steps = [
    { heading: "Enroll in FBM", content: "Sign up for the FBM program by filling out the registration form." },
    { heading: "Send Inventory to Maelano", content: "Ship your products to Maelano’s fulfillment centers." },
    { heading: "Maelano Stores Products", content: "Maelano stores your products securely in our warehouses." },
    { heading: "Customer Places Order", content: "Customers place orders for your products on Maelano." },
    { heading: "Maelano Packs and Ships", content: "Maelano packs and ships the orders to customers." },
    { heading: "Maelano Handles Customer Service and Returns", content: "Maelano manages customer service and handles returns on your behalf." },
];

export const data = [
    {
        id: 1,
        service: "Storage Fee",
        description: "Monthly fee for storing products in Maelano's warehouse.",
        fee: "$0.75 per cubic foot/month",
    },
    {
        id: 2,
        service: "Fulfillment Fee",
        description: "Fee for picking, packing, and shipping each unit.",
        fee: "Starting at $2.50 per unit",
    },
    {
        id: 3,
        service: "Returns Processing Fee",
        description: "Fee for handling customer returns.",
        fee: "$1.50 per return",
    },
    {
        id: 4,
        service: "Long-Term Storage Fee",
        description: "Additional fee for items stored for over 6 months.",
        fee: "$6.90 per cubic foot/month",
    },
];

export const columns = [
    {
        name: "Service",
        selector: (row) => row.service,
        maxWidth: "400px",
        minWidth: "220px",
    },
    {
        name: "Description",
        selector: (row) => row.description,
        minWidth: "300px",
    },
    {
        name: "Fee",
        selector: (row) => row.fee,
        minWidth: "250px",
    },
];

export const formFields = [
    { id: "sellerId", label: "Seller ID", type: "text", placeholder: "Enter Seller Id" },
    { id: "businessName", label: "Business Name", type: "text", placeholder: "Enter Business Name" },
    { id: "contactPerson", label: "Contact Person", type: "text", placeholder: "Enter Contact Person" },
    { id: "contactEmail", label: "Contact Email", type: "email", placeholder: "Enter Contact Email" },
    { id: "contactNumber", label: "Contact Number", type: "number", placeholder: "Enter Contact Number" },
    { id: "businessAddress", label: "Business Address", type: "text", placeholder: "Enter Business Address" },
    { id: "preferredWarehouse", label: "Preferred Warehouse", type: "select", options: ["Warehouse 1", "Warehouse 2", "Warehouse 3"], },
    { id: "productCategories", label: "Product Categories", type: "text", placeholder: "Enter Product Categories" },
    { id: "monthlyVolume", label: "Estimated Monthly Volume", type: "text", placeholder: "Enter Estimated Monthly Volume" },
    { id: "additionalNotes", label: "Additional Notes", type: "textarea", placeholder: "Enter Additional Notes" },
];

export const customStyles = {
    table: {
        style: {
            border: '1px solid #D9D9D9',
        },
    },
    header: {
        style: {
            fontSize: '15px',
            padding: '0',
            fontWeight: '400',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            fontSize: '15px',
            div: {
                whiteSpace: "normal",
                overflow: "visible",
            },
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '20px',
            div: {
                whiteSpace: "normal !important",
                overflow: "visible !important",
            },
        },
    },
};
